var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _circle, _mask, _path6, _path7, _path8, _ellipse, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.25,
    y: 21.375,
    width: 33,
    height: 32.25,
    rx: 3,
    fill: "#E4EEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.25,
    y: 21.375,
    width: 69.75,
    height: 32.25,
    rx: 3,
    fill: "#E4EEFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.25,
    y: 56.625,
    width: 33,
    height: 32.25,
    rx: 3,
    fill: "#E4EEFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.25,
    y: 56.625,
    width: 33.75,
    height: 32.25,
    rx: 3,
    fill: "#E4EEFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 56.625,
    width: 33,
    height: 32.25,
    rx: 3,
    fill: "#E4EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 33.375L17 46.125L14.75 46.125L14.75 33.375L17 33.375Z",
    fill: "#C6DAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 28.875L23 46.125L20.75 46.125L20.75 28.875L23 28.875Z",
    fill: "#C6DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.25 40.875L28.25 46.125L26 46.125L26 40.875L28.25 40.875Z",
    fill: "#C6DAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 35.625L33.5 46.125L31.25 46.125L31.25 35.625L33.5 35.625Z",
    fill: "#C6DAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 45.375L35 45.375L35 46.875L13.25 46.875L13.25 45.375Z",
    fill: "#C6DAFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 73.125,
    r: 8,
    fill: "#F0F8FF",
    stroke: "#E4EEFF",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_11481_27454",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 62.625C22.6569 62.625 20.8462 63.1102 19.25 64.0317C17.6538 64.9533 16.3283 66.2788 15.4067 67.875C14.4852 69.4712 14 71.2819 14 73.125C14 74.9681 14.4852 76.7788 15.4067 78.375C16.3283 79.9712 17.6538 81.2967 19.25 82.2183C20.8462 83.1398 22.6569 83.625 24.5 83.625C26.3431 83.625 28.1538 83.1398 29.75 82.2183C31.3462 81.2967 32.6717 79.9712 33.5933 78.375L24.5 73.125L24.5 62.625Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 62.625C22.6569 62.625 20.8462 63.1102 19.25 64.0317C17.6538 64.9533 16.3283 66.2788 15.4067 67.875C14.4852 69.4712 14 71.2819 14 73.125C14 74.9681 14.4852 76.7788 15.4067 78.375C16.3283 79.9712 17.6538 81.2967 19.25 82.2183C20.8462 83.1398 22.6569 83.625 24.5 83.625C26.3431 83.625 28.1538 83.1398 29.75 82.2183C31.3462 81.2967 32.6717 79.9712 33.5933 78.375L24.5 73.125L24.5 62.625Z",
    fill: "#C6DAFF",
    stroke: "#E4EEFF",
    strokeWidth: 4,
    mask: "url(#path-12-inside-1_11481_27454)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0849 81.8094C46.6629 81.8094 35.75 70.9494 35.75 57.5922C35.75 44.2351 46.6629 33.375 60.0849 33.375C73.507 33.375 84.4198 44.2351 84.4198 57.5922C84.4198 70.9494 73.507 81.8094 60.0849 81.8094ZM60.0849 36.604C48.4582 36.604 38.9947 46.0218 38.9947 57.5922C38.9947 69.1627 48.4582 78.5805 60.0849 78.5805C71.7116 78.5805 81.1752 69.1627 81.1752 57.5922C81.1752 46.0218 71.7116 36.604 60.0849 36.604Z",
    fill: "#C6DAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4729 78.0891L78.9663 79.5884C77.5344 81.0134 77.5344 83.3238 78.9663 84.7488L93.8029 99.5137C95.2349 100.939 97.5565 100.939 98.9884 99.5137L100.495 98.0144C101.927 96.5893 101.927 94.2789 100.495 92.8539L85.6585 78.0891C84.2265 76.664 81.9049 76.664 80.4729 78.0891Z",
    fill: "#C6DAFF",
    stroke: "#C6DAFF",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.125,
    cy: 57.375,
    rx: 21.375,
    ry: 21,
    fill: "#F0F8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1702 54.0411C45.0404 54.0411 44.8998 54.0196 44.77 53.9658C44.2185 53.7397 43.9481 53.1155 44.1644 52.5666C46.3383 47.1527 50.7835 43.0304 56.3643 41.276C56.9375 41.093 57.5432 41.4051 57.7162 41.9756C57.9001 42.546 57.5864 43.1487 57.0132 43.321C52.0489 44.8816 48.1012 48.5411 46.1652 53.363C45.9922 53.7828 45.592 54.0411 45.1594 54.0411H45.1702Z",
    fill: "#C6DAFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8618 60.8215C43.267 60.8215 42.7803 60.3372 42.7803 59.7452C42.7803 58.7335 42.856 57.711 43.0182 56.71C43.1156 56.118 43.6671 55.7305 44.2512 55.8166C44.846 55.9135 45.2462 56.4624 45.1489 57.0436C45.0083 57.9262 44.9434 58.8411 44.9434 59.7452C44.9434 60.3372 44.4567 60.8215 43.8618 60.8215Z",
    fill: "#C6DAFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboard);
export default __webpack_public_path__ + "static/media/empty_dashboard.f489f07fd95bd3a5edeec689d8b2fc8e.svg";
export { ForwardRef as ReactComponent };